import React from 'react';
import QuickSignup from '../QuickSignUp/QuickSignup';

export default function QuickSignupWrapper({ customer, setCustomer, onTabChange }) {
    const handleComplete = (createdCustomer) => {
        // When signup completes, set the created customer to QuickLink state
        if (createdCustomer) {
            setCustomer(createdCustomer);
            // Switch to Apply Coupon tab (index 3) after customer is created
            if (onTabChange) {
                onTabChange(null, 3);
            }
        }
        // Don't call onSnippetComplete - keep user in QuickLink to use other tabs
    };

    return (
        <QuickSignup onComplete={handleComplete} hideHeader={true} />
    );
}

